import React from 'react';
import { InputText } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import './updateContact.scss';
import Alert from '../shared/Alert/Alert';
import { FORM_KEYS } from '../../constants/formKeys';

const UpdateContact = ({
  type = 'email',
  title,
  inputName,
  inputLabel = 'New phone number',
  inputPlaceholder = 'Enter your new mobile number. e.g. 04XX XXX XXX',
  onCancelClick,
  onUpdateClick,
  inputLength,
  onInputChange,
  updateButtonLabel = 'Update contact',
  validation,
  errorMessage
}) => {
  const formContext = useFormContext();

  const disabledUpdateButton =
    type === 'phone'
      ? formContext.formState.errors?.[FORM_KEYS.NEW_MOBILE_NUMBER]?.message ||
        !formContext.watch(FORM_KEYS.NEW_MOBILE_NUMBER)
      : formContext.formState.errors?.[FORM_KEYS.NEW_EMAIL]?.message || !formContext.watch(FORM_KEYS.NEW_EMAIL);

  return (
    <div>
      {title && <h1 className="pageTitle">{title}</h1>}
      {errorMessage && (
        <Alert
          type="error"
          message={errorMessage}
        />
      )}
      <InputText
        name={inputName}
        label={inputLabel}
        placeholder={inputPlaceholder}
        maxLength={inputLength}
        validation={validation}
        fieldFormContext={formContext}
        customChangeHandler={onInputChange}
      />
      <div className="actionButtonBars">
        <button
          type="button"
          className="button primary outline"
          onClick={onCancelClick}
        >
          <span className="labelText">Cancel</span>
        </button>
        <button
          type="button"
          className="button primary"
          onClick={onUpdateClick}
          disabled={disabledUpdateButton}
        >
          <span className="labelText">{updateButtonLabel}</span>
        </button>
      </div>
    </div>
  );
};

UpdateContact.propTypes = {
  type: PropTypes.oneOf(['phone', 'email']).isRequired,
  title: PropTypes.string.isRequired,
  inputLabel: PropTypes.string.isRequired,
  inputName: PropTypes.string.isRequired,
  onCancelClick: PropTypes.func.isRequired,
  onUpdateClick: PropTypes.func.isRequired,
  inputPlaceholder: PropTypes.string,
  inputLength: PropTypes.number,
  onInputChange: PropTypes.func,
  updateButtonLabel: PropTypes.string,
  validation: PropTypes.shape({}),
  errorMessage: PropTypes.string
};

export default UpdateContact;
